import React from "react";
/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';

import 'rc-collapse/assets/index.css';
import FeaturesAccordionItemQuestionItem from './featuresaccordion-itemquestion';

function FeaturesAccordionItemQuestion(props) {
  const items = props.questionData;
  const questionData = items.map(( item, index ) =>
    // Key should be specified inside the array.
    <FeaturesAccordionItemQuestionItem
      key={index.toString()}
      value={item} 
      />
  );
  
  return (
    <span>
       {questionData}
    </span>
  );
}

const FeaturesAccordionQuestions = ({ translate, props }) => {
    return (
            <span>
                <FeaturesAccordionItemQuestion questionData={props.value.questionsData} />
            </span>
    );
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

//wrapping components using withRouter for menu active class update
export default withRouter(connect(mapStateToProps)(FeaturesAccordionQuestions));



// WEBPACK FOOTER //
// ./src/components/features/featuresaccordion-item.jsx